var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n"),React.createElement("path",{"className":"st0","d":"M477.1,466.7L361.9,582.9c-9.2,8.2-18.3,8.2-26.5-1L221.3,466.7c-10.2-18.3-8.2-29.6,19.4-31.6l86.6,1V132.5\r\n\tc0-12.2,9.2-21.4,21.4-21.4c12.2,0,22.4,9.2,22.4,21.4v303.7l88.7,1C484.2,439.2,491.3,448.4,477.1,466.7L477.1,466.7z","key":1})]);
}

ArrowDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 700 700","style":{"enableBackground":"new 0 0 700 700"},"xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
